class VipSection {
    constructor(vipTiers) {
        this.vipTiers = vipTiers;
    }

    renderVipTiers() {
        //console.log(this.vipTiers)
        this.vipTiers.forEach((tier, ind) => {
            $(`.vip-info-container.${tier.name.toLowerCase()} .swell-points-multiplier`).html(
                `${tier.pointsMultiplier}x point multiplier`
            )
        });

        this.slickIfMobile();
    }

    slickIfMobile() {
        //on page load
        window.matchMedia("(min-width: 800px)").addListener(function (e) {
            if (e.matches && $('.slick-initialized').length > 0) {
                $(".vip-container .benefits-container").slick('unslick');
                console.log('unslick')
            } else {
                console.log('slick')
                $(".vip-container .benefits-container").slick({
                    dots: true,
                    arrows: false,
                    appendDots: $('.swell-rewards-vip .slick-button-container')
                    /* appendArrows: $('.swell-rewards-vip .slick-button-container'),
                    nextArrow: "<i class='fa fa-chevron-right' aria-hidden='true'></i>",
                    prevArrow: "<i class='fa fa-chevron-left' aria-hidden='true'></i>" */
                });
            }
        });
        // changes to screen size after page load 
        if (window.matchMedia("(max-width: 800px)").matches) {
            $(".vip-container .benefits-container").slick({
                dots: true,
                arrows: false,
                appendDots: $('.swell-rewards-vip .slick-button-container'),
                /* nextArrow: "<i class='fa fa-chevron-right' aria-hidden='true'></i>",
                 prevArrow: "<i class='fa fa-chevron-left' aria-hidden='true'></i>" */
            });
        }
        // https://hacks.mozilla.org/2012/06/using-window-matchmedia-to-do-media-queries-in-javascript/
    }

    //VipSection.renderVipStatus(swellAPI.getCustomerDetails().vipTier, swellAPI.getVipTiers(), swellAPI.getCustomerDetails().email);

    static renderVipStatus(currentVipTier, vipTiersArray, customerEmail) {
        let IdsArray = vipTiersArray.map(tier => {
            return tier.id;
        });

        if (customerEmail !== undefined) {
            let currentTier = 0;

            if (currentVipTier === null) {
                currentTier = 0
            } else {
                currentTier = IdsArray.indexOf(currentVipTier.id) + 1;
            }
            //console.log(currentTier);
            $(".vip-info-container .current-status").eq(currentTier).removeClass('swell-hidden').css('display', 'inline-block')
        }
    }

    renderVipHeader(customerTierObject) {
        if (customerTierObject === null) {
            $('.current-status-header').append('Bronze')
        } else {
            $('.current-status-header').append(customerTierObject.name)
        }

    }
}